import React from "react";

/**
 * Card de seleção de cor do grupo.
 */
export default function ColorConfigCard({
  listCollor,
  selectedId,
  selectedColor,
  onColorChange,
}) {
  return (
    <div className="card col-md-12 p-3">
      <h5 className="mb-3">Cor atribuida a todos os veiculos do grupo</h5>
      <div className="col-sm-4 d-flex">
        <select
          name="colors"
          className="form-control me-2"
          onChange={onColorChange}
          value={selectedId || "0"}
        >
          <option value={"0"}>USAR COR DO VEÍCULO</option>
          {listCollor &&
            listCollor.map((color, index) => (
              <option key={index} value={color.colorId}>
                {color.description}
              </option>
            ))}
        </select>

        <div
          style={{
            display: selectedId == 0 || !selectedId ? "none" : "block",
            width: "90px",
            height: "40px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            backgroundColor: selectedColor || "transparent",
          }}
        />
      </div>
    </div>
  );
}
